import { InsightsType } from './insightTypes';

export const initialState: InsightsType = {
  fetching: false,
  success: null,
  error: null,
  statusCode: null,
  invoicingRevenueInsightsData: [],
  invoicingExpensesInsightsData: []
}